export default {
  apiKey: "AIzaSyDGZly51wxc9gZPyiYu3RoyIS9yJwvoVvQ",
  authDomain: "worldstrides.firebaseapp.com",
  databaseURL: "https://worldstrides.firebaseio.com",
  projectId: "worldstrides",
  storageBucket: "worldstrides.appspot.com",
  messagingSenderId: "795231542794",
  appId: "1:795231542794:web:d246aa8bb475d3c5e7c9f3",
};
